import type { Entries } from 'type-fest';

import getProductData from 'utils/get-product-data';

type HomepageType = 'men' | 'women';

class Homepage {
  private storageKey = 'SELECTED_HOMEPAGE';
  private pageType = theme.pageType;

  constructor() {
    switch (this.pageType) {
      case 'page':
        {
          for (const [key, value] of Object.entries(theme.homepages) as Entries<
            typeof theme.homepages
          >) {
            if (location.pathname === value) {
              this.setSelectedHomepage(key);
            }
          }
        }
        break;

      case 'product': {
        const data = getProductData();

        if (!data) {
          return;
        }

        if (data.tags.includes('gender:male')) {
          this.setSelectedHomepage('men');
        } else if (data.tags.includes('gender:female')) {
          this.setSelectedHomepage('women');
        }
      }
    }
  }

  getSelectedHomepage() {
    const item = localStorage.getItem(this.storageKey);

    if (!item) {
      return null;
    }

    if (item in theme.homepages) {
      return theme.homepages[item as HomepageType];
    }

    return null;
  }

  setSelectedHomepage(value: HomepageType) {
    localStorage.setItem(this.storageKey, value);
  }
}

const Singleton = new Homepage();

export default Singleton;
